import React from "react";
import { ListChildComponentProps } from "react-window";
import { APICategory, UnreleasedAPICategory } from "../../../../../../../../models/Entities";
import { SyncSelection } from "../types";
import SyncSelectionRow from "./SyncSelectionRow";

export interface SyncSelectionsListData {
  category: APICategory | UnreleasedAPICategory;
  selections: SyncSelection[];
}

const SyncSelectionsListRow = ({
  index,
  style,
  data,
}: ListChildComponentProps<SyncSelectionsListData>) => (
  <SyncSelectionRow
    category={data.category}
    selection={data.selections[index]}
    showTopBorder={index > 0}
    style={style}
  />
);

export default SyncSelectionsListRow;
